import { VisitTypeAssignment } from "./VisitTypeAssignment";
import { DentallyTreatment } from "./DentallyTreatment";
import { OrganizationSubscription } from "./OrganizationSubscription";
export class IntegrationData {
  code: string;
  visitTypeAssignments: VisitTypeAssignment[];
  treatments: DentallyTreatment[];
  treatmentCategories: any[];
  step: "Introduction" | "Authorization" | "LearnHow"| "Start" ;
  subscriptions:OrganizationSubscription[];
}


